// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","card":"oB3jZoGzoDqlQ506AhtGA","column":"_2n_wS9s5aWv0bvGQQhtxyx","row":"_3_e-XxmiZTiY5WNQieBWgR"};